import { ChargingPointScreenProps } from './types'

import InProgressChargingSessionScreen from './InProgressChargingSessionScreen'

const IdleChargingSessionScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return <InProgressChargingSessionScreen {...props} />
}

export default IdleChargingSessionScreen
